var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9351 10.0539C34.1107 8.0842 31.5626 6.99951 28.7501 6.99951C25.9226 6.99951 23.366 8.07764 21.5501 10.0351C19.7145 12.0142 18.8201 14.7039 19.0301 17.6083C19.4463 23.3383 23.8067 27.9995 28.7501 27.9995C33.6935 27.9995 38.0463 23.3392 38.4692 17.6101C38.682 14.732 37.782 12.0479 35.9351 10.0539Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 48.9995H12.25C11.8181 49.0051 11.3903 48.9144 10.9979 48.7339C10.6054 48.5534 10.2581 48.2877 9.9813 47.9561C9.37192 47.2276 9.1263 46.233 9.30817 45.227C10.0994 40.8376 12.5688 37.1504 16.45 34.562C19.8982 32.2642 24.266 30.9995 28.75 30.9995C33.2341 30.9995 37.6019 32.2651 41.05 34.562C44.9313 37.1495 47.4007 40.8367 48.1919 45.2261C48.3738 46.232 48.1282 47.2267 47.5188 47.9551C47.242 48.2869 46.8948 48.5528 46.5023 48.7335C46.1099 48.9141 45.6821 49.005 45.25 48.9995Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolo);
export default __webpack_public_path__ + "static/media/solo.aec69a23429eebd803827ec2c4ac41a6.svg";
export { ForwardRef as ReactComponent };